<template>
    <text-field
        v-model="fieldValue"
        :v="v"
        :placeholder="placeholder"
        :name="name"
        class="uk-padding-remove-top"
        @onEnter="updateValue"
    />
</template>

<script>

import _ from 'lodash';

export default {
    components: {
        TextField: () => import("@strangeanimals/common-vue-components/src/components/fields/TextField")
    },
    props: {
        value: {
            type: [String, Number],
            default: null
        },
        placeholder: {
            type: String,
            default: "Input"
        },
        name: {
            type: String,
            default: "FieldName"
        },
        v: {
            type: Object,
            default: () => {
                return null;
            }
        }
    },
    data() {
        return {
            buffer: null
        };
    },
    computed: {
        fieldValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.buffer = value;
                this.debounceInput(value);
            }
        }
    },
    methods: {
        debounceInput: _.debounce(function (value) {
            this.updateValue(value);
        }, 1000),
        updateValue() {
            this.$emit("input", this.buffer);
        }
    }
}
</script>
